<script>
import options from './StafetDonationStepPrivat.options'
export default options
</script>

<template>
  <article
    class="kb-stafet-step kb-stafet-donation-step-privat kb-optimizely-forms"
  >
    <h2 class="kb-stafet-step__title">
      {{ labels.yourSupportTitle }}
    </h2>
    <div>
      <div
        class="kb-stafet-step__input-wrapper kb-stafet-step__input-wrapper--half-half"
      >
        <FormInputTextField
          v-model="firstName"
          fieldName="firstName"
          :modelValue="firstName"
          :label="labels.yourInformationFirstNameLabel"
          :isRequired="true"
          :onChangeCallback="(e) => validateField('firstName', e.target.value)"
          :errorMessageLabel="labels.yourInformationFirstNameErrorMessage"
          :isValidationError="showFirstNameErrorMessage"
        />

        <FormInputTextField
          v-model="lastName"
          fieldName="lastName"
          :modelValue="lastName"
          :label="labels.yourInformationLastNameLabel"
          :isRequired="true"
          :onChangeCallback="(e) => validateField('lastName', e.target.value)"
          :errorMessageLabel="labels.yourInformationLastNameErrorMessage"
          :isValidationError="showLastNameErrorMessage"
        />
      </div>

      <FormInputTextField
        v-model="email"
        fieldName="email"
        :modelValue="email"
        :label="labels.yourInformationEmailLabel"
        :isRequired="true"
        type="email"
        :errorMessageLabel="labels.yourInformationEmailErrorMessage"
        :onChangeCallback="(e) => validateField('email', e.target.value)"
        :isValidationError="showEmailErrorMessage"
      />
    </div>

    <div class="kb-stafet-step__input-wrapper">
      <FormCheckbox
        fieldName="isAnonymous"
        :modelValue="isAnonymous.toString()"
        v-model="isAnonymous"
        :label="labels.yourInformationAnonymousCheckbox"
        :errorMessageLabel="labels.yourInformationAnonymousCheckboxErrorMessage"
        :onChangeCallback="
          (e) => validateField('isAnonymous', e.target.checked)
        "
      />
      <FormCheckbox
        fieldName="taxDeduction"
        :modelValue="taxDeduction.toString()"
        v-model="taxDeduction"
        :label="labels.yourInformationTaxDeductionCheckbox"
        :errorMessageLabel="labels.yourInformationTaxDeductionCheckboxErrorMessage"
        :tooltipText="labels.yourInformationTaxDeductionCheckboxTooltip"
        :onChangeCallback="(e) => setTaxDeduction(e.target.checked)"
      />

      <FormInputTextField
        v-if="taxDeduction"
        v-model="cpr"
        fieldName="cpr"
        :modelValue="cpr"
        :label="labels.yourInformationCprLabel"
        :isRequired="true"
        :maxlength="11"
        :errorMessageLabel="labels.yourInformationCprErrorMessage"
        :onChangeCallback="(e) => validateField('cpr', e.target.value)"
        :isValidationError="showCprErrorMessage"
      />
    </div>

    <StafetPayment
      :title="labels.yourInformationTotalTitle"
      :basket="basket"
      :inTotalLabel="labels.yourInformationTotal"
      :inTotalPrice="basketTotalPrice.toString()"
    />

    <StafetActions
      :nextStepCallback="() => nextStepCallback(stepModel)"
      :nextStepLabel="labels.formNavigationLastStep"
      :previousStepCallback="() => previousStepCallback(stepModel)"
      :previousStepLabel="labels.formNavigationPreviousStep"
    />
  </article>
</template>
